import { GetterTree } from 'vuex';
import * as types from './types'

export default <GetterTree<RootState, RootState>>{
    [types.SIDEBAR_VISIBLE](state) {
        return state.showSidebar
    },

    [types.CURRENT_MENU](state) {
        return state.currentMenu
    },

    [types.GLOBAL_BUSY](state) {
        return state.loading
    },

    [types.CURRENT_PAGE](state) {
        return state.currentPage
    },
}